const regexToMatchConditionalVariableContent =
  /{{#if.*?}}((.|\t|\r|\n)*?){{else.*?}}((.|\t|\r|\n)*?){{\/if}}/g;
const regexToMatchConditionalVariableClass = /class="conditionalVariables"/g;

export const conditionalVariableContentAsString = (taskName: string) => {
  return (
    taskName
      ?.replace(
        regexToMatchConditionalVariableClass,
        'class="conditionalVariablesContent"',
      )
      ?.replace(regexToMatchConditionalVariableContent, (match, firstMatch) => {
        return firstMatch;
      }) ?? ''
  );
};
